import { Overlay } from '@eti/components';
import { useEffect, useState } from 'react';
import { getCheapestUpgradeSegment, selectedSegmentUpgradeTotalPrice, setAddToCartButtonFocus, setNoThanksButtonFocus } from '../../utils/utils';
import { CABIN_UPGRADE } from '../../../products';
import CabinUpgradeSelection from './CabinUpgradeSelection';
import CabinUpgradeSummary from './CabinUpgradeSummary';
import CabinUpgradeContentInfoCard from './CabinUpgradeContentInfoCard';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CabinUpgradeDrawer = _ref => {
  let {
    availabilityTexts,
    isOpen,
    isProductSelected,
    isUpgradeSaved,
    segmentUpgradeList,
    selectedUpgrades = [],
    setIsDrawerOpen,
    unselectedUpgrades,
    updateSelectedCabinUpgrades
  } = _ref;
  const [initialSelectedOptions] = useState(() => getCheapestUpgradeSegment(segmentUpgradeList));
  const [selectedCabinUpgradeOptions, setSelectedCabinUpgradeOptions] = useState(initialSelectedOptions);
  const [unselectedCabinUpgrades, setUnselectedCabinUpgrades] = useState({});
  const totalPrice = selectedSegmentUpgradeTotalPrice(Object.values(selectedCabinUpgradeOptions));
  useEffect(() => {
    // watch for product, when it gets unselected, then we have to reset all values
    if (!isProductSelected) {
      setSelectedCabinUpgradeOptions(initialSelectedOptions);
      setUnselectedCabinUpgrades({});
    }
  }, [isProductSelected, initialSelectedOptions]);
  const onClose = () => {
    setIsDrawerOpen(false);
    const alreadySelectedUpgrades = Object.fromEntries(selectedUpgrades.map(item => [item.value, item]));
    const updatedSelectedOption = Object.keys(alreadySelectedUpgrades).length ? alreadySelectedUpgrades : initialSelectedOptions;
    if (!isUpgradeSaved) {
      const selection = {
        value: '',
        selectedUpgrades: [],
        unselectedUpgrades: {},
        priceRaw: totalPrice
      };
      setSelectedCabinUpgradeOptions(updatedSelectedOption);
      setUnselectedCabinUpgrades({});
      updateSelectedCabinUpgrades(selection);
      setNoThanksButtonFocus();
    } else {
      setAddToCartButtonFocus();
      const hasUnselectedUpgrades = Object.keys(unselectedUpgrades).length;
      setSelectedCabinUpgradeOptions(updatedSelectedOption);
      if (hasUnselectedUpgrades) {
        setUnselectedCabinUpgrades(unselectedUpgrades);
      } else {
        setUnselectedCabinUpgrades({});
      }
    }
  };
  const onSave = () => {
    const selectedCabinUpgrades = Object.values(selectedCabinUpgradeOptions);
    const selection = {
      value: selectedCabinUpgrades.length ? 'true' : 'false',
      selectedUpgrades: selectedCabinUpgrades,
      unselectedUpgrades: unselectedCabinUpgrades,
      priceRaw: totalPrice
    };
    updateSelectedCabinUpgrades(selection);
    setIsDrawerOpen(false);
    if (!selectedCabinUpgrades.length) {
      setNoThanksButtonFocus();
    } else {
      setAddToCartButtonFocus();
    }
  };
  const handleOpen = () => {
    const addToCartButton = document.getElementById(`${CABIN_UPGRADE.name}_true`);
    addToCartButton === null || addToCartButton === void 0 || addToCartButton.blur();
    return isOpen;
  };
  const {
    drawerAdditionalContentText = [],
    drawerSaveButtonLabel,
    drawerTitle,
    drawerTotalPriceLabel
  } = availabilityTexts.drawer;
  return /*#__PURE__*/_jsxs(Overlay.Drawer, {
    dataTestId: `${CABIN_UPGRADE.name}-drawer`,
    handleClose: onClose,
    isOpen: handleOpen(),
    shouldOpenHorizontally: true,
    children: [/*#__PURE__*/_jsx(Overlay.Header, {
      onClose: onClose,
      title: drawerTitle
    }), /*#__PURE__*/_jsxs(Overlay.Content, {
      "data-testid": `${CABIN_UPGRADE.name}-drawer-content`,
      children: [/*#__PURE__*/_jsx(CabinUpgradeSelection, {
        availabilityTexts: availabilityTexts,
        segmentUpgradeList: segmentUpgradeList,
        selectedCabinUpgradeOptions: selectedCabinUpgradeOptions,
        setSelectedCabinUpgradeOptions: setSelectedCabinUpgradeOptions,
        setUnselectedCabinUpgrades: setUnselectedCabinUpgrades,
        unselectedCabinUpgrades: unselectedCabinUpgrades
      }), /*#__PURE__*/_jsx(CabinUpgradeContentInfoCard, {
        drawerAdditionalContentText: drawerAdditionalContentText
      })]
    }), /*#__PURE__*/_jsx(Overlay.Footer, {
      children: /*#__PURE__*/_jsx(CabinUpgradeSummary, {
        buttonLabel: drawerSaveButtonLabel,
        onSave: onSave,
        totalPrice: totalPrice,
        totalPriceLabel: drawerTotalPriceLabel
      })
    })]
  });
};
export default CabinUpgradeDrawer;
//# sourceMappingURL=CabinUpgradeDrawer.js.map